export default {
    location: window.location,
    getElementById: (id) => document.getElementById(id),
    querySelector: (selector) => document.querySelector(selector),
    scrollY: window.scrollY,
    hbspt: () => window.hbspt,
    timeZone: () => window.timeZone,
};
